Keys = require 'data/keys'
KeyChars = require 'data/key-chars'
KeyLocations = require 'data/key-locations'
RussianKeys = require 'data/russian-keyboard'

module.exports =
  getKey: (e) ->
    switch e.type
      when 'keydown', 'keyup'
        if (locationName = KeyLocations[e.which])?
          Keys[locationName]
        else
          Keys.Unknown
      when 'keypress'
        # guide/hacks/russian
        if (char = KeyChars[e.which] ? RussianKeys[e.which])?
          Keys[char]
        else
          Keys.Unknown
      else
        throw Error("Can't getKey for this event")

  isArrow: (key) ->
    key in [Keys.ArrowLeft, Keys.ArrowRight, Keys.ArrowUp, Keys.ArrowDown]

  isSubmitEvent: (e) ->
    if e.type != 'keydown'
      throw Error("Checking for submit only works on keydown")

    @getKey(e) in [Keys.Enter, Keys.LineFeed]

  isForceSubmitEvent: (e) ->
    ( @isSubmitEvent(e) && (e.ctrlKey || e.metaKey) ) && !e.shiftKey



// WEBPACK FOOTER //
// ./app/scripts/lib/keyboard.coffee